import { S3_URL } from 'constants';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { Button } from 'react-bootstrap';

const InfoCard = ({ content, slug, index, handleModalVisibility }: any) => {
	const { title, subtitle, description, logo } = content ?? {};

	return (
		<div>
			<div className="added-content d-flex flex-column gap-3 mt-3">
				<div className="added-content-box bg-white p-2 p-sm-3 position-relative">
					<div className="d-flex align-items-center gap-2 gap-sm-3">
						{logo && (
							<img
								src={`${S3_URL}${logo}`}
								alt="img"
								className="organization-logo rounded"
								loading="lazy"
							/>
						)}
						<div className="d-flex flex-column gap-0 gap-sm-1">
							<h6 className="m-0 fw-bold">{title}</h6>
							<p className="organization-name m-0">{description}</p>
							<p className="work-duration m-0">{subtitle}</p>
						</div>
					</div>
					<Button
						className="border-0 p-0 delete-info text-decoration-none btn-link rounded-circle"
						onClick={() => handleModalVisibility(slug, index)}
					>
						<i className="ri-close-line"></i>
						{/* <img src={IMAGE_PATHS.removeicon} alt="img" /> */}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default InfoCard;
